/* eslint-disable import/prefer-default-export */
export const CALENDAR_SCROLL_DISTANCE = 294;
export const CALENDAR_MINIMUM_SCROLL_SPEED = 300;
